// components/LoadingSpinner.jsx
import React from "react";

const LoadingSpinner = ({ message = "Please Wait..." }) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-2xl shadow-xl p-8 max-w-sm w-full mx-4">
        {/* Spinner */}
        <div className="flex justify-center mb-6">
          <div className="w-16 h-16 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
        </div>

        {/* Message */}
        <div className="text-center mb-6">
          <p className="text-lg font-medium text-gray-700">{message}</p>
        </div>
      </div>
    </div>
  );
};

export default LoadingSpinner;
